// NOTE: This file is in .prettierignore
global.fetch = require("cross-fetch");

import { Auth } from "aws-amplify";
import { setCookie } from "lib/loginHelpers.js";



// This runs on app load - is there a current user session?
export function checkForCurrentSession(projectCookie) {
	return (dispatch) => {
		// Check for logged in user
		return Auth.currentAuthenticatedUser()
			.then((user) => {
				// Does this user need to change their password?
				if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
					dispatch({ type: "forcePasswordUpdate", user, userJustLoggedIn: false });
				} else {
					dispatch({ type: "logInSuccess", user, lastProject: projectCookie });
				}
			})
			.catch((error) => dispatch({ type: "notLoggedIn", error }));
	};
}

export function attemptLogIn(username, password, lastProject) {
	return (dispatch) => {
		dispatch({ type: "attemptingLogIn" });
		return Auth.signIn(username, password)
			.then((user) => {
				// Does this user need to change their password?
				if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
					dispatch({ type: "forcePasswordUpdate", user, userJustLoggedIn: true });
				} else {
					dispatch({ type: "logInSuccess", user, lastProject });
				}
			})
			.catch((error) => dispatch({ type: "logInError", error }));
	};
}

export function setAPI(api) {
	return {
		type: "setAPI",
		api,
	};
}
export function setProjectTheme(projectTheme) {
	return {
		type: "setProjectTheme",
		projectTheme: projectTheme || false,
	};
}
// This invalidates "currentProject", which causes the whole app to rerender & load the new project data
export function setProject(project) {
	setCookie("project", project.id);
	return {
		type: "setProject",
		project: project.id,
	};
}

export function setBrowserType(browser) {
	console.log('setBrowserType', browser);
	
	return {
		type: "setBrowserType",
		browser,
	};
}

// --------- Controlled inputs --------------
export function updateLoginEmail(email) {
	return {
		type: "updateLoginEmail",
		email,
	};
}
export function updatePassword(password) {
	return {
		type: "updatePassword",
		password,
	};
}
export function updateChangePasswordNew(password) {
	return {
		type: "updateChangePasswordNew",
		password,
	};
}
export function updateChangePasswordOld(password) {
	return {
		type: "updateChangePasswordOld",
		password,
	};
}
export function updateLoginVerificationCode(code) {
	return {
		type: "updateLoginVerificationCode",
		code,
	};
}
export function updateLoginNewPassword(password) {
	return (dispatch) => {
		dispatch({
			type: "updateLoginNewPassword",
			password,
		});
	};
}

export function signOut() {
	return (dispatch) => {
		dispatch({ type: "closeUserDropdown" });
		return Auth.signOut()
			.then(() =>
				dispatch({
					type: "signedOut",
				})
			)
			.catch((error) =>
				dispatch({
					type: "signedOut",
					error,
				})
			);
	};
}

// Forgot Password
export function recoverPassword(username) {
	return (dispatch) => {
		dispatch({ type: "attemptingLogIn" });
		// docs: https://aws.github.io/aws-amplify/api/classes/authclass.html#forgotpassword
		return Auth.forgotPassword(username)
			.then((user) =>
				dispatch({
					type: "recoverPasswordSuccess",
					user,
					username,
				})
			)
			.catch((error) =>
				dispatch({
					type: "recoverPasswordError",
					error,
				})
			);
	};
}
export function openForgotPasswordView() {
	return {
		type: "openForgotPasswordView",
	};
}
export function backToLogin() {
	return {
		type: "backToLogin",
	};
}

export function openChangePasswordModal() {
	return {
		type: "openChangePasswordModal",
	};
}
export function closeChangePasswordModal() {
	return {
		type: "closeChangePasswordModal",
	};
}

// Submits new password, then logs user in (2 API calls)
export function resetPassword(code, password) {
	return (dispatch, getState) => {
		const username = getState().login.stashUsername;
		dispatch({ type: "attemptingLogIn" });
		// docs: https://aws.github.io/aws-amplify/api/classes/authclass.html#forgotpasswordsubmit
		return Auth.forgotPasswordSubmit(username, code, password)
			.then(() =>
				// docs: https://aws.github.io/aws-amplify/api/classes/authclass.html#signin
				Auth.signIn(username, password)
					.then(() =>
						dispatch({
							type: "resetPasswordSuccess",
						})
					)
					.catch((error) =>
						dispatch({
							type: "resetPasswordError",
							error,
						})
					)
			)
			.catch((error) =>
				dispatch({
					type: "resetPasswordError",
					error,
				})
			);
	};
}

// Changes password for an already Cognito CONFIRMED user
export function changePassword(currentPassword, newPassword) {
	return (dispatch, getState) => {
		dispatch({ type: "attemptingLogIn" });
		const { userData } = getState().login;
		// docs: https://aws.github.io/aws-amplify/api/classes/authclass.html#changepassword
		return Auth.changePassword(userData, currentPassword, newPassword)
			.then((user) =>
				dispatch({
					type: "changePasswordSuccess",
					user,
					userData,
				})
			)
			.catch((error) =>
				dispatch({
					type: "changePasswordError",
					error,
				})
			);
	};
}

// Createa a password for a FORCE_CHANGE_PASSWORD user (when they log in for the first time)
export function createOriginalPassword(currentPassword, newPassword) {
	return (dispatch, getState) => {
		dispatch({ type: "attemptingLogIn" });
		// The original user response is a CognitoUser instance, which has the method completeNewPasswordChallenge
		const { userData } = getState().login;
		// docs: https://docs.aws.amazon.com/cognito/latest/developerguide/using-amazon-cognito-identity-user-pools-javascript-example-authenticating-admin-created-user.html
		return userData.completeNewPasswordChallenge(
			newPassword,
			{},
			{
				onSuccess: (user) => {
					dispatch({
						type: "createOriginalPasswordSuccess",
						userData,
					});
				},
				onFailure: (error) => {
					dispatch({
						type: "createOriginalPasswordError",
						error,
					});
				},
			}
		);
	};
}

